import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import type { FC } from 'react';

import type { DeviceStep } from 'constants/deviceInstructions';

const DeviceStepContent: FC<DeviceStep> = ({ image, alt, text }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const smallScreen = useMediaQuery(
    `(max-width:${theme.breakpoints.values.sm + 70}px)`,
  );

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Image
        src={image}
        alt={alt}
        width={400}
        height={smallScreen ? 150 : 270}
        style={{
          width: '100%',
          padding: '10px 0',
          objectFit: 'contain',
        }}
      />
      <Typography mt={1} variant="body1" fontWeight={500} textAlign="center">
        {t(text)}
      </Typography>
    </Box>
  );
};

export default DeviceStepContent;
